const rankingItems = [
  { rank: 1, title: '《时空穿梭者：终局》', category: '科幻动作', hot: '987万', trend: 'up', change: '+5' },
  { rank: 2, title: '《长安夜未央》', category: '古装悬疑', hot: '852万', trend: 'up', change: '+3' },
  { rank: 3, title: '《极地求生：零下72小时》', category: '灾难冒险', hot: '768万', trend: 'up', change: '+12' },
  { rank: 4, title: '《她的名字叫春天》', category: '都市情感', hot: '691万', trend: 'down', change: '-2' },
  { rank: 5, title: '《深海异兽：觉醒》', category: '奇幻惊悚', hot: '623万', trend: 'up', change: '+8' },
  { rank: 6, title: '《武动苍穹·剑指天下》', category: '武侠玄幻', hot: '584万', trend: 'new', change: 'NEW' },
];

function getRankIcon(rank: number) {
  if (rank === 1) return 'ri-medal-fill text-accent-500';
  if (rank === 2) return 'ri-medal-fill text-foreground-300';
  if (rank === 3) return 'ri-medal-fill text-primary-400';
  return null;
}

function getTrendIcon(trend: string) {
  if (trend === 'up') return 'ri-arrow-up-line text-green-500';
  if (trend === 'down') return 'ri-arrow-down-line text-red-400';
  return 'ri-flashlight-line text-accent-500';
}

export default function SectionRanking() {
  return (
    <section id="ranking" className="bg-background-100 py-16 md:py-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-3">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap mb-3">
              实时热播
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              热播榜单
            </h2>
            <p className="text-foreground-600 text-sm mt-1">全网热门影视实时排行，数据每30分钟更新</p>
          </div>
          <div className="flex gap-2">
            <button className="px-3 py-1.5 text-xs font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap cursor-pointer transition-colors">
              电影榜
            </button>
            <button className="px-3 py-1.5 text-xs font-medium rounded-full bg-background-50 text-foreground-600 border border-background-200 whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors">
              剧集榜
            </button>
            <button className="px-3 py-1.5 text-xs font-medium rounded-full bg-background-50 text-foreground-600 border border-background-200 whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors">
              综艺榜
            </button>
          </div>
        </div>

        <div className="space-y-2">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 cursor-pointer transition-colors group"
            >
              <div className="w-8 md:w-10 flex-shrink-0 text-center">
                {getRankIcon(item.rank) ? (
                  <i className={`${getRankIcon(item.rank)} text-lg md:text-xl`}></i>
                ) : (
                  <span className="font-heading text-lg md:text-xl font-bold text-foreground-400">
                    {item.rank}
                  </span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>
              <div className="flex items-center gap-1.5 text-xs md:text-sm">
                <span className="text-foreground-500">{item.hot}热度</span>
              </div>
              <div className={`flex items-center gap-0.5 text-xs md:text-sm whitespace-nowrap ${
                item.trend === 'up' ? 'text-green-600' : item.trend === 'down' ? 'text-red-500' : 'text-accent-600'
              }`}>
                <i className={getTrendIcon(item.trend)}></i>
                <span className="font-medium">{item.change}</span>
              </div>
              <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0">
                <i className="ri-play-circle-fill text-primary-500 text-xl md:text-2xl"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}